<form [formRoot]="form" class="app-form">
  @if (loginMethod().includes('mobile') && loginMethod().includes('email')) {
  <div ngTabs>
    <ul
      ngTabList
      selectionMode="explicit"
      [selectedTab]="'' + active()"
      (selectedTabChange)="tabChange(+$event)"
      class="nav nav-tabs"
    >
      <li class="nav-item" role="presentation">
        <button
          type="button"
          ngTab
          value="1"
          #emailTabRef="ngTab"
          class="nav-link text-left tracking-theme"
          [class.active]="emailTabRef.selected()"
        >
          <strong id="emailTab">{{ 'LABELS.EMAIL' | translate }}</strong>
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          type="button"
          ngTab
          value="2"
          #mobileTabRef="ngTab"
          class="nav-link text-left tracking-theme"
          [class.active]="mobileTabRef.selected()"
        >
          <strong id="mobileTab">{{ 'LABELS.MOBILE' | translate }}</strong>
        </button>
      </li>
    </ul>

    <div class="tab-content mt-2">
      <div
        ngTabPanel
        value="1"
        #emailPanel="ngTabPanel"
        class="tab-pane fade starting:opacity-0"
        [class.active]="emailPanel.visible()"
        [class.show]="emailPanel.visible()"
      >
        <ng-template ngTabContent>
          <ng-container [ngTemplateOutlet]="emailField" [ngTemplateOutletContext]="{ showLabel: false }"></ng-container>
        </ng-template>
      </div>
      <div
        ngTabPanel
        value="2"
        #mobilePanel="ngTabPanel"
        class="tab-pane fade starting:opacity-0"
        [class.active]="mobilePanel.visible()"
        [class.show]="mobilePanel.visible()"
      >
        <ng-template ngTabContent>
          <ng-container
            [ngTemplateOutlet]="mobileField"
            [ngTemplateOutletContext]="{ showLabel: false }"
          ></ng-container>
        </ng-template>
      </div>
    </div>
  </div>
  } @else { @if (loginMethod().includes('email')) {
  <ng-container [ngTemplateOutlet]="emailField" [ngTemplateOutletContext]="{ showLabel: true }"></ng-container>
  } @if (loginMethod().includes('mobile')) {
  <ng-container [ngTemplateOutlet]="mobileField" [ngTemplateOutletContext]="{ showLabel: true }"></ng-container>
  } }
</form>

<ng-template #emailField let-showLabel="showLabel">
  <div class="form-group">
    @if (showLabel) {
    <label class="col-form-label">{{ 'LABELS.EMAIL_ADDRESS' | translate }}</label>
    }
    <input
      class="form-control"
      [formField]="form.email"
      placeholder="name@email.com"
      autocomplete="username"
      inputmode="email"
      type="email"
      id="username"
      appFormFieldOnError
    />
  </div>
</ng-template>

<ng-template #mobileField let-showLabel="showLabel">
  <div class="form-group">
    @if (showLabel) {
    <label class="col-form-label">{{ 'LABELS.MOBILE_NUMBER' | translate }}</label>
    }
    <div [class.input-group]="!showLabel">
      <app-phone-number-input
        [preferredCountries]="preferredCountries"
        [initialCountry]="'za'"
        [separateDialCode]="separateDialCode"
        [formField]="form.mobile"
        name="phone"
        appFormFieldOnError
      >
      </app-phone-number-input>
    </div>
  </div>
</ng-template>
